import moment from 'moment-timezone';

const isInFluSeason = (date: any) => {
  const month = Number(moment(date).format('M'));
  const fluSeasonMonths = [9, 10, 11, 12, 1, 2];
  return fluSeasonMonths.includes(month);
};

const getNumDaysFromTodayDate = (numDays: any) =>
  moment().tz('utc').add(numDays, 'days').format('YYYY-MM-DD');

export { isInFluSeason, getNumDaysFromTodayDate };
